import { DirectDepositMethod } from './Interstitial'

const BackButtonTapped = {
  object_name: 'directDepositSearchBack',
  screen: 'directDepositSearch',
  screen_name: 'directDepositSearch',
  cta_title: '',
}

const SearchButtonTapped = (searchTerm) => ({
  object_name: 'directDepositSearch',
  screen: 'directDepositSearch',
  screen_name: 'directDepositSearch',
  employer_name: searchTerm,
})

const setupContainer = () => ({
  object_name: 'bankingDirectDepositSetUp',
  screen_name: 'bankingDirectDepositSetUp',
})

const setupCTA = (depositMethod: DirectDepositMethod) => {
  const method =
    depositMethod === DirectDepositMethod.Pinwheel
      ? 'linkWithPayrollProvider'
      : 'getDepositForm'
  return {
    object_name: 'bankingDirectDepositSetUp',
    screen_name: 'bankingDirectDepositSetUp',
    direct_deposit_method: method,
  }
}

const setupExit = () => ({
  object_name: 'bankingDirectDepositExit',
  screen_name: 'bankingDirectDepositSetUp',
})

const disclosureView = () => ({
  object_name: 'bankingDirectDepositDisclosure',
  screen: 'bankingDirectDepositDisclosure',
})

const disclosureCTA = (title: string) => ({
  object_name: 'bankingDirectDepositDisclosure',
  screen: 'bankingDirectDepositDisclosure',
  cta_title: title,
})

const disclosureExit = () => ({
  object_name: 'bankingDirectDepositExit',
  screen: 'bankingDirectDepositDisclosure',
})

const pinWheelModal = () => ({
  object_name: 'bankingDirectDepositPinwheel',
  screen: 'bankingDirectDepositPinwheel',
  pinwheel_event: 'OPEN',
})

const pinWheelSuccess = () => ({
  object_name: 'bankingDirectDepositPinwheel',
  screen: 'bankingDirectDepositPinwheel',
  pinwheel_event: 'SUCCESS',
})

const payrollError = (error: string) => ({
  object_name: 'bankingDirectDepositPayrollProviderError',
  screen: 'bankingDirectDepositPayrollProviderError',
  pinwheel_error_code: error,
})

export {
  SearchButtonTapped,
  BackButtonTapped,
  setupContainer,
  setupCTA,
  setupExit,
  disclosureView,
  disclosureCTA,
  disclosureExit,
  pinWheelModal,
  pinWheelSuccess,
  payrollError,
}
